import type { InputNumberDesignTokens } from '@primeuix/themes/types/inputnumber';

export const INPUT_STYLES: InputNumberDesignTokens = {
  button: {
    width: '2rem',
  },
  css: ({ dt }) => `
    .p-inputnumber-input.p-filled.p-invalid {
      color:  ${dt('error')};
    }

    .p-inputnumber.p-inputnumber-stacked .p-inputnumber-button .p-icon {
      width: 0.75rem;
      height: 0.75rem;
    }`,
};
